import { CSSProperties } from "react";
import styled from "styled-components";

export const getTimerStyle = (isPortrait: boolean): CSSProperties => ({
	fontSize: isPortrait ? "1.1em" : "1.265em",
	padding: isPortrait ? "0.5em 0.7em 0.6em" : "0.5em 0.7em",
	position: "relative",
	top: 0,
	left: 0
});

export const Container = styled.div`
	position: absolute;
	top: 1em;
	left: 1em;

	> div {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.5em;
	}
`;
